<template>
    <div class="CatalogItem" v-once>
        <img class="CatalogItem__image" :src="item.image">
        <div class="CatalogItem__header">{{item.name}}</div>
        <div class="CatalogItem__description">{{item.description}}</div>
        <div class="CatalogItem__bottom">
            <BaseButtonFlat v-if="item.isGroup"
                            :label="'CATALOG__OPEN'"
                            @click="openGroup(item)" />
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import BaseButtonFlat from '../common/BaseButtonFlat.vue';

    export default {
        name: 'CatalogItem',
        components: {
            BaseButtonFlat
        },
        props: {
            //Items containing id, name, description, isGroup marker and image.
            item: {
                type: Object
            }
        },
        methods: {
            ...mapActions({
                openGroup: 'catalog/openGroup'
            })
        }
    };
</script>


<style>
    .CatalogItem {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        margin: 8px 8px 2px 8px;
        border-radius: 2px;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        background-color: white;
    }

    @media (max-width: 600px) {
        .CatalogItem {
            width: 100%;
        }
    }

    @media (max-width: 960px) and (min-width: 600px) {
        .CatalogItem {
            width: 45%;
        }
    }

    @media (max-width: 1280px) and (min-width: 960px) {
        .CatalogItem {
            width: 30%;
        }
    }

    @media (min-width: 1280px) {
        .CatalogItem {
            width: 20%;
        }
    }

    .CatalogItem__image {
        max-width: 100%;
        height: auto;
        min-height: 1px;
        border-radius: 2px 2px 0 0;
    }

    .CatalogItem__header {
        padding: 24px 16px 0 16px;
        font-size: 1.5rem;
        font-weight: 400;
        letter-spacing: normal;
        line-height: 2rem;
        margin: 0;
    }

    .CatalogItem__description {
        flex: 1 1 auto;
        padding: 8px 16px 16px 16px;
        color: rgba(0, 0, 0, 0.87);
    }

    .CatalogItem__bottom {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

</style>


// WEBPACK FOOTER //
// CatalogItem.vue?231b77e1